/*
 * @Author: 刘小博
 * @Date: 2023-02-17 14:45:39
 * @LastEditTime: 2023-02-19 17:01:41
 * @LastEditors: 肖玲
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\intelligentize-report\fight-map\modules\clientFolwRouter.js
 * 终端流向
 */
const clientFolwRouter = [
  // 终端流向数据---作战地图
  {
    path: '/intelligenceReports/battle-map/terminal-flow',
    name: 'intelligenceReportsBattleMapTerminalFlow',
    component: () =>
      import(
        /*webpackChunkName:"intelligenceReportsBattleMapTerminalFlow" */
        // '@/views/intelligenceReports/battle-map/terminalFlow.vue'
        '@/views/intelligentize-report/fight-map/client-folw/client-folw-data/Page.vue'
      ),
    meta: {
      SecondaryMenu: '终端流向', //二级菜单
      title: '终端流向数据',
    },
  },
]
export default clientFolwRouter
